import { CreditsGateProps } from './Types'
import { PressResponder } from '@react-aria/interactions'
import { observer } from 'mobx-react-lite'
import { useCreditsGate } from './useCreditsGate'

const CreditsGate = observer(({ charge, children, onPress, ...pressProps }: CreditsGateProps) => {
  const handlePress = useCreditsGate(charge, onPress)

  return (
    <PressResponder onPress={handlePress} {...pressProps}>
      {children}
    </PressResponder>
  )
})

export { CreditsGate }
